import React from 'react';
import SectionHeader from './SectionHeader';
import Field from './Field';
import styles from '../SaleReportPage.module.scss';

const MapIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 3 3 5v16l6-2 6 2 6-2V3l-6 2-6-2Z" />
    <path d="M9 3v16M15 5v16" />
  </svg>
);

const spinnerStyle = {
  width: 28,
  height: 28,
  border: '3px solid #e8e4da',
  borderTop: '3px solid #c9a961',
  borderRadius: '50%',
  animation: 'reportSpin 0.8s linear infinite',
};

function ImageSlot({ imageUrl, loading, label }) {
  if (imageUrl) {
    return (
      <div
        className={`${styles.photoDrop} ${styles.photoDropFilled}`}
        style={{
          backgroundImage: `url(${imageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          minHeight: '300px',
        }}
      />
    );
  }
  return (
    <div className={styles.photoDrop} style={{
      minHeight: '300px',
      cursor: 'default',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 10,
    }}>
      {loading ? (
        <>
          <style>{`@keyframes reportSpin { to { transform: rotate(360deg); } }`}</style>
          <div style={spinnerStyle} />
          <span className={styles.photoDropMain} style={{ fontSize: 13, color: '#8a92a3' }}>
            {label} 불러오는 중...
          </span>
        </>
      ) : (
        <span className={styles.photoDropSub} style={{ color: '#b0a898' }}>
          {label} 이미지를 가져올 수 없습니다
        </span>
      )}
    </div>
  );
}

function LocationSection({ config, imagePending = [] }) {
  return (
    <>
      <SectionHeader
        icon={<MapIcon />}
        title="위치 · 지적도 이미지"
      />
      <div className={styles.grid}>
        <Field label="위치" span={6}>
          <ImageSlot
            imageUrl={config.mapImage}
            loading={imagePending.includes('map')}
            label="위치"
          />
        </Field>
        <Field label="지적도" span={6}>
          <ImageSlot
            imageUrl={config.cadastralImage}
            loading={imagePending.includes('cadastral')}
            label="지적도"
          />
        </Field>
      </div>
    </>
  );
}

export default LocationSection;
